exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".icon__icon--1wYIN{fill:currentColor}\n", "",{"version":3,"sources":["/home/admin/alg-onb-workspace/alg-truffe-fe/src/components/ui/atoms/icon/icon.scss"],"names":[],"mappings":"AAAA,mBAGE,iBAAkB","file":"icon.scss","sourcesContent":[".icon {\n  //max-width: 100%;\n  //max-height: 100%;\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);

// Exports
exports.locals = {
	"icon": "icon__icon--1wYIN"
};